/*
 * gift-option.js — [Platypus 2026-08-26, rebuilt 2026-09-22]
 *
 * Drives the "Make it a gift" checkbox in snippets/gift-option.liquid (cart drawer + /cart).
 *
 * WHY THIS IS A THEME ASSET AND NOT AN INLINE <script> IN A SECTION:
 * this theme navigates by fetching the next page and writing it into the body with innerHTML
 * (see updatePage() in global.js). A <script> inserted through innerHTML never executes, so an
 * inline script runs on a hard page load and never again. Every listener here is bound to
 * `document`, which is never replaced, so it keeps working across every navigation.
 *
 * WHAT IT DOES:
 * 1. Checkbox change -> saves cart attribute "Gift Order" ("Yes" / removed) straight to the cart.
 *    The cart is the only source of truth; the drawer re-renders from it.
 * 2. Cart emptied -> the choice and the marker are cleared (attributes outlive the items).
 * 3. Checkout click -> writes MARKER as the first line of the order note (or removes it), then
 *    lets checkout continue. The warehouse reads the order note. Express checkout buttons
 *    (Shop Pay etc.) skip this step; the "Gift Order" attribute still reaches the order.
 *
 * The marker is stripped from the note textarea in Liquid (cart-drawer / main-cart-footer), so
 * the shopper never sees it in their own note. Keep MARKER identical in both places.
 */
(function () {
  'use strict';

  if (window.__lfdGiftOption) return;
  window.__lfdGiftOption = true;

  var ATTR = 'Gift Order';
  var MARKER = '*** GIFT ORDER - pack in gift box ***';

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';
  }

  function post(body) {
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed: ' + res.status);
      return res.json();
    });
  }

  function stripMarker(note) {
    return (note || '')
      .split('\n')
      .filter(function (line) { return line.trim() !== MARKER; })
      .join('\n')
      .replace(/^\s+/, '');
  }

  function giftBoxes() {
    return document.querySelectorAll('[data-gift-order]');
  }

  // 1. Save the choice the moment it changes
  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!box || !box.matches || !box.matches('[data-gift-order]')) return;

    var on = box.checked;
    giftBoxes().forEach(function (b) { b.checked = on; }); // drawer and /cart stay in sync

    var attributes = {};
    attributes[ATTR] = on ? 'Yes' : ''; // a blank value removes the attribute
    post({ attributes: attributes }).catch(function (err) {
      giftBoxes().forEach(function (b) { b.checked = !on; });
      console.warn('[gift-option]', err);
    });
  });

  // 2. An emptied cart forgets the choice. Shopify keeps cart attributes (and the note) after every
  //    item is removed, so without this a shopper who once ticked the box finds it ticked on their
  //    next, unrelated cart. Checked once per tab, and after every cart change the theme announces.
  function resetIfEmpty() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var marked = (cart.note || '').indexOf(MARKER) !== -1;
        if (cart.item_count > 0 || (!cart.attributes[ATTR] && !marked)) return;
        var attributes = {};
        attributes[ATTR] = '';
        var body = { attributes: attributes };
        if (marked) body.note = stripMarker(cart.note);
        return post(body).then(function () {
          giftBoxes().forEach(function (b) { b.checked = false; });
        });
      })
      .catch(function (err) { console.warn('[gift-option]', err); });
  }

  resetIfEmpty();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, resetIfEmpty);
  }

  // 3. On checkout, mirror the choice into the order note
  var submitting = false;

  document.addEventListener('click', function (event) {
    if (submitting) return;
    var button = event.target.closest && event.target.closest('button[name="checkout"]');
    if (!button || !button.form) return;

    var boxes = giftBoxes();
    if (!boxes.length) return; // no gift option on this page: leave checkout alone

    event.preventDefault();
    var on = boxes[0].checked;
    var textarea = document.getElementById(button.id === 'CartDrawer-Checkout' ? 'CartDrawer-Note' : 'Cart-note');

    var getNote = textarea
      ? Promise.resolve(textarea.value)
      : fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { return cart.note; });

    getNote
      .then(function (note) {
        var base = stripMarker(note);
        var newNote = on ? (base ? MARKER + '\n' + base : MARKER) : base;
        // The theme's own note field saves on a debounce. Give it the same value, so a late save
        // from it cannot overwrite the marker.
        if (textarea) textarea.value = newNote;
        var attributes = {};
        attributes[ATTR] = on ? 'Yes' : '';
        return post({ note: newNote, attributes: attributes });
      })
      .catch(function (err) {
        console.warn('[gift-option]', err); // never block a sale over this
      })
      .then(function () {
        submitting = true;
        setTimeout(function () { submitting = false; }, 4000); // back button / bfcache
        if (button.form.requestSubmit) button.form.requestSubmit(button);
        else button.click();
      });
  });
})();
